export enum CognitoErrorEnum {
  UsernameExistsException = "UsernameExistsException",
}
